/* Classic.js */

"use strict";
//const Registrations = require("../../RegistrationNamespaces");

module.exports = {
    name: "classic",
    label: "Config Model Editor",
    pageTitle: "Gluware Model Editor",
    helpLink: "Config%20Modeling/Model-configuration-changes.htm",
    disabled: false,
    order: 5, // Deprecated -- Newer solution uses order from index.js
    navIcon: "classic.solution",
    steve2Path: "/_app_/gluware_control/#!/s/Perspective/rd/",
    app: "gluware_control",
    section: "Perspective",
    license: ["GLUWARE", "CME"],
    accessPerm: ["modelEditorAccess"],
    iconName: "branding.advanced",
    navOptions: {
        nodes: {
            name: "Nodes",
            options: {
                rd: {
                    perspectiveFilter: {construct: "node"},
                },
            },
            type: "exp",
        },
        domains: {
            name: "Domains",
            options: {
                rd: {
                    perspectiveFilter: {construct: "domain"},
                },
            },
            type: "exp",
        },
        features: {
            name: "Features",
            options: {
                rd: {
                    perspectiveFilter: {construct: "feature"},
                },
            },
            type: "exp",
        },
        globals: {
            name: "Globals",
            options: {
                rd: {
                    perspectiveFilter: {construct: "global"},
                },
            },
            type: "exp",
        },
        scripts: {
            name: "Scripts",
            options: {
                rd: {
                    perspectiveFilter: {construct: "script"},
                },
            },
            type: "exp",
        },
    },
};
